import Tooltip from './WithdrawalTooltip'
export default Tooltip
